import { useQuery } from '@tanstack/react-query';
import { getInvoices } from '../Services/InvoiceService';

const useGetInvoices = (params, options) =>
    useQuery({
        queryKey: ['getInvoices', params],
        queryFn: () => getInvoices(params),
        ...options,
    });

export default useGetInvoices;
